import React, { useEffect } from "react";
import "./Home.css"; // Keep your custom CSS file import

import { useSelector, useDispatch } from "react-redux";
import { getSpecials } from "../actions/specials";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Box, // Used for layout and spacing
} from "@mui/material";
import { useTheme } from "@mui/material/styles"; // Import useTheme
import HomeIcon from "@mui/icons-material/Home";
import DiscountIcon from "@mui/icons-material/Discount";

// Removed: import { makeStyles } from "@mui/styles";
// Removed: useStyles definition

function Specials() {
  const dispatch = useDispatch();
  const specials = useSelector((state) => state.specials);
  const navigate = useNavigate();
  const theme = useTheme(); // Access the theme

  //retrieve all the specials in database
  useEffect(() => {
    dispatch(getSpecials());
  }, [dispatch]);

  // --- Styling Objects (Replaces makeStyles) ---
  const headerContainerSx = {
    flexGrow: 1,
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  };

  const navButtonContainerSx = {
    display: "flex",
    gap: theme.spacing(1), // Space between buttons
  };

  const cardSx = {
    width: "100%",
    maxWidth: 500, // Fixed width for presentation
    alignSelf: "center",
    marginTop: theme.spacing(3),
    display: "flex",
    boxShadow: theme.shadows[5], // Stronger shadow for emphasis
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.secondary.light}`, // Highlight border
  };

  const codeSx = {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    borderRadius: theme.shape.borderRadius,
    fontWeight: 700,
    letterSpacing: "0.1em",
    textAlign: "center",
  };

  return (
    <React.Fragment>
      <AppBar position="static">
        <Toolbar sx={headerContainerSx}>
          <Typography
            variant="h5"
            component="div"
            sx={{ fontWeight: 600, display: "flex", alignItems: "center" }}
          >
            <DiscountIcon sx={{ mr: 1 }} /> Specials
          </Typography>
          <Box sx={navButtonContainerSx}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<HomeIcon />}
              onClick={() => navigate("/")}
              sx={{ color: "#fff" }}
            >
              Go to Home Page
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Box sx={{ padding: theme.spacing(4) }}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ fontWeight: 700, textAlign: "center", mb: 4 }}
        >
          Current Promotions
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {specials.specialsList && specials.specialsList.length > 0 ? (
            specials.specialsList.map((tile, index) => (
              <Grid
                item
                xs={12}
                key={index}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Card sx={cardSx}>
                  <CardActionArea>
                    <CardContent>
                      <Typography
                        variant="h6"
                        component="h3"
                        sx={{
                          fontWeight: 700,
                          color: theme.palette.secondary.main,
                          textAlign: "center",
                          mb: 1,
                        }}
                      >
                        {tile.title}
                      </Typography>

                      <Typography
                        variant="body1"
                        color="textSecondary"
                        component="p"
                        sx={{ textAlign: "center", mb: 2 }}
                      >
                        {tile.text}
                      </Typography>

                      <Typography
                        variant="body2"
                        color="textPrimary"
                        component="p"
                        sx={{ textAlign: "center", fontWeight: "bold" }}
                      >
                        Type: {tile.type}
                      </Typography>

                      {tile.code && (
                        <Box sx={codeSx}>
                          <Typography
                            variant="subtitle1"
                            component="span"
                            sx={{ fontSize: "1.2rem", color: "white" }}
                          >
                            USE CODE: **{tile.code}**
                          </Typography>
                        </Box>
                      )}
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))
          ) : (
            <Typography
              variant="subtitle1"
              color="textSecondary"
              sx={{ mt: 5 }}
            >
              No current specials available. Check back soon!
            </Typography>
          )}
        </Grid>
      </Box>
    </React.Fragment>
  );
}

export default Specials;
